import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=3addc7d6&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=3addc7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3addc7d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/.jenkins/workspace/platform_dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3addc7d6')) {
      api.createRecord('3addc7d6', component.options)
    } else {
      api.reload('3addc7d6', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=3addc7d6&scoped=true&", function () {
      api.rerender('3addc7d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CommonTable/Pagination.vue"
export default component.exports